// React and related imports
import React from 'react';

// Interfaces and Enums
import { IMedia } from '../../common/interfaces/Media.interface';
import { MediaTypes } from '../../common/enums/MediaTypes';

// Icons
import { HiOutlineVideoCamera } from 'react-icons/hi';

// Images
import audioPlaceholder from '../../assets/images/audio-file.png';
import documentPlaceholder from '../../assets/images/pdf.png';

interface MediaThumbnailProps {
  item: IMedia;
}

export const MediaThumbnail: React.FC<MediaThumbnailProps> = ({ item }) => {
  switch (item.type) {
    case MediaTypes.IMAGE:
      return (
        <img
          src={item.url}
          alt={item.name}
          className="h-full w-full transform object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
      );
    case MediaTypes.VIDEO:
      return (
        <>
          <video
            src={item.url}
            className="h-full w-full object-cover"
            muted
            autoPlay
            loop
          />
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <div className="rounded-full bg-black/50 p-2">
              <HiOutlineVideoCamera className="h-6 w-6 text-white" />
            </div>
          </div>
        </>
      );
    case MediaTypes.SOUND:
      return (
        <img
          src={audioPlaceholder}
          alt={item.name}
          className="h-full w-full transform object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
      );
    case MediaTypes.DOCUMENT:
      return (
        <img
          src={documentPlaceholder}
          alt={item.name}
          className="h-full w-full transform object-cover transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
      );
    default:
      return null;
  }
};
